import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { AttendeeModel } from './attendee.model';

export class EventModel {
  public id!: string;
  public creator!: string;
  public originalCreator!: string;
  public calendarId!: string;
  public titolo!: string;
  public sig!: string;
  public nome!: string;
  public cognome!: string;
  public cellulare!: string;
  public sig2!: string;
  public nome2!: string;
  public cognome2!: string;
  public cellulare2!: string;
  public date!: Date;
  public dataInizio!: NgbDateStruct;
  public dataFine!: NgbDateStruct;
  public dataOraInizio!: Date;
  public dataOraFine!: Date;
  public oraInizio!: string;
  public oraFine!: string;
  public tipoEvento!: number;
  public eventoOggetto!: string;
  public rifImmobile!: any;
  public luogo!: string;
  public note!: string;
  public confermato!: boolean;
  public attendees = new Array<any>();
}
